import { useState, useCallback } from 'react';
import { NativeSyntheticEvent, NativeScrollEvent } from 'react-native';
import { SCROLL_TOP_THRESHOLD } from '@components/common/NCFile/constants/ncFileViewer.constants';

export const useScrollTopButton = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleScroll = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const offsetY = event.nativeEvent.contentOffset.y;
    setShowScrollTop(offsetY > SCROLL_TOP_THRESHOLD);
  }, []);

  return { showScrollTop, handleScroll };
};
